import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import SharedByMeList from "../componentes/SharedByMeList"
import FileManager from "../componentes/test-newPageHome/newFilesUP"
import "../Css/FilePage.css"
import MenuUser from "../componentes/MenuUser"
import CreateFileMenu from "../componentes/CreateFileMenu"
import { useContextMenu } from "../hooks/useContextMenu" 

export default function AppPage() {
  const [user, setUser] = useState(null)
  const [userEmail, setUserEmail] = useState(null)
  const [loading, setLoading] = useState(true)
  const [token, setToken] = useState(null)
  const [activeTab, setActiveTab] = useState("myfiles")
  const navigate = useNavigate()

  // 🎯 Hook para menú contextual
  const { isOpen: isMenuOpen, position: menuPosition, openMenu, closeMenu } = useContextMenu()

  // Función para cargar datos del usuario
  const loadUserData = async() => {
    console.log("🔍 Cargando datos de usuario...")

    const storedToken = localStorage.getItem("authToken")
    const storedEmail = localStorage.getItem("userEmail")
    const userId = getCookieFromDocument("userId")

    console.log("📧 Email en localStorage:", storedEmail)
    console.log("🔑 Token en localStorage:", storedToken ? "Existe" : "No existe")
    console.log("🆔 UserId en cookie:", userId ? "Existe" : "No existe")

    if (storedToken && userId) {
      setToken(storedToken)
      setUser({ id: userId, email: storedEmail })

      if (storedEmail) {
        console.log("✅ Email encontrado:", storedEmail)
        setUserEmail(storedEmail)
      } else {
        console.warn("⚠️ Email no encontrado, intentando obtener de Firebase...")
        tryGetEmailFromFirebase()
      }
    } else {
      console.warn("⚠️ Datos de autenticación incompletos")
    }
  }

  // Función para intentar obtener email de Firebase
  const tryGetEmailFromFirebase = async () => {
    try {
      const { auth } = await import("../firebase")
      const currentUser = auth.currentUser

      if (currentUser && currentUser.email) {
        console.log("🔥 Email obtenido de Firebase:", currentUser.email)
        const email = currentUser.email

        localStorage.setItem("userEmail", email)
        setUserEmail(email)
        setUser((prev) => ({ ...prev, email }))
      } else {
        console.error("❌ No se pudo obtener email de Firebase Auth")
      }
    } catch (error) {
      console.error("❌ Error al acceder a Firebase Auth:", error)
    }
  }

  // Cargar datos del usuario al inicio
useEffect(() => {
  const fetchData = async () => {
    await loadUserData()
    setLoading(false)
  }
  fetchData()
}, [])

  // Redirigir si no hay usuario después de cargar
  useEffect(() => {
    if (!loading && !user) {
      console.log("🚫 Usuario no autenticado, redirigiendo...")
      navigate("/login")
    }
  }, [loading, user, navigate])

  function getCookieFromDocument(name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(";").shift()
    return null
  }

  // Manejador para cambiar de pestaña
  const handleTabChange = (tab) => {
    console.log("🔄 Cambiando a pestaña:", tab, "con userEmail:", userEmail)
    setActiveTab(tab)
  }

    // 🎯 Manejar creación de archivo desde menú contextual
  const handleFileCreated = (newFile) => {
    console.log("✅ Nuevo archivo creado:", newFile)

    // Actualizar la lista de archivos
    //handleGetFiles()

    // Mostrar notificación
    alert(`✅ ${newFile.fileName} creado exitosamente!`)
  }

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner-large"></div>
        <p>Cargando tu nube privada...</p>
      </div>
    )
  }

  if (!user) {
    return (
      
      <div className="auth-required">
        <div className="auth-required-content">
          <div className="auth-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
            </svg>
          </div>
          <h2>Acceso Restringido</h2>
          <p>Debes iniciar sesión para acceder a tu nube privada</p>
          <div className="auth-buttons">
            <a href="/login" className="btn-login">
              Iniciar Sesión
            </a>
            <a href="/register" className="btn-register">
              Registrarse
            </a>
          </div>
        </div>
      </div>
    )
  }

  console.log("🖥️ Renderizando AppPage - activeTab:", activeTab, "userEmail:", userEmail)

  return (
    <div className="app-container"
        onContextMenu={e => {
      e.preventDefault(); // Evita el menú nativo
      openMenu(e);        // Abre tu menú contextual personalizado
    }}
    >
      <div>PROBANDO CAMBIO EN APPPAGE</div>
      <header className="app-header">
        <div className="app-header-content">
          <div className="app-logo">CloudPriv</div>
          <nav className="app-nav">
            <a href="/" className="nav-link">
              Inicio
            </a>
            <a
              href="#"
              className={`nav-link${activeTab === "myfiles" ? " active" : ""}`}
              onClick={(e) => {
                e.preventDefault()
                handleTabChange("myfiles")
              }}
            >
              Mis Archivos
            </a>
            <a
              href="#"
              className={`nav-link${activeTab === "shared" ? " active" : ""}`}
              onClick={(e) => {
                e.preventDefault()
                handleTabChange("shared")
              }}
            >
              Compartidos
            </a>
            <a
              href="#"
              className={`nav-link${activeTab === "sharedbyme" ? " active" : ""}`}
              onClick={e => { e.preventDefault(); setActiveTab("sharedbyme") }}
            >
              Compartidos por mí
            </a>
            <a href="#" className="nav-link">
              Papelera
            </a>
          </nav>
          <div className="user-menu">
            <MenuUser
              userEmail={userEmail || "Usuario"}
              onLogout={() => {
                console.log("🚪 Cerrando sesión...")
                localStorage.removeItem("authToken")
                localStorage.removeItem("userEmail")
                document.cookie = "userId=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT"
                navigate("/login")
              }}
            />
          </div>
        </div>
      </header>

      <main className="app-main">
        {/* Debug info */}
        <div className="debug-panel">
          <h4>🐛 Debug Info:</h4>
          <p>
            ActiveTab: <strong>{activeTab}</strong>
          </p>
          <p>
            UserEmail: <strong>{userEmail || "undefined"}</strong>
          </p>
          <p>
            User: <strong>{user ? "Existe" : "No existe"}</strong>
          </p>
          <button onClick={loadUserData} className="debug-btn">
            🔄 Recargar datos de usuario
          </button>
        </div>

        {/* Mostrar SharedByMeList solo en la pestaña correspondiente */}
        {activeTab === "sharedbyme" ? (
          <SharedByMeList userEmail={userEmail} />
        ) : (
          <FileManager key={activeTab} mode={activeTab} userEmail={userEmail} />
        )}

      {/* 🎯 Menú contextual para crear archivos */}
      <CreateFileMenu
        isOpen={isMenuOpen}
        position={menuPosition}
        onClose={closeMenu}
        onFileCreated={handleFileCreated}
      />
      </main>

      <footer className="app-footer">
        <p>&copy; 2024 CloudPriv. Todos los derechos reservados.</p>
      </footer>
    </div>
  )
}